import { CTX_MORE, CTX_TEXT_SIZE } from "../../Toolbar";

export const S_NEW_PAGE = "shortcut/newPage";
export const S_LINK = "shortcut/link";
export const S_IMAGE = "shortcut/image";
export const S_ALIGN_LEFT = "shortcut/leftAlign";
export const S_ALIGN_RIGHT = "shortcut/rightAlign";
export const S_ALIGN_CENTER = "shortcut/centerAlign";
export const S_LTR = "shortcut/ltr";
export const S_RTL = "shortcut/rtl";
export const S_ARABIC = "shortcut/arabic";
export const S_TEXTSIZE_1 = "shortcut/textSize1";
export const S_TEXTSIZE_2 = "shortcut/textSize2";
export const S_TEXTSIZE_3 = "shortcut/textSize3";
export const S_TEXTSIZE_4 = "shortcut/textSize4";
export const S_TEXTSIZE_5 = "shortcut/textSize5";
export const S_TEXTSIZE_6 = "shortcut/textSize6";
export const S_SOURCE_CODE = "shortcut/sourceCode";
export const S_REMOVE_FORMAT = "shortcut/removeFormat";

const table: Record<string, string> = {
    "alt+ctrl+n": S_NEW_PAGE, // alt+ctrl+n
    "ctrl+k": S_LINK, // ctrl+k
    "ctrl+i": S_IMAGE, // ctrl+i
    "ctrl+[": S_ALIGN_LEFT, // ctrl+[
    "ctrl+]": S_ALIGN_RIGHT, // ctrl+]
    "ctrl+.": S_ALIGN_CENTER, // ctrl+.
    "ctrl+shift+e": S_LTR, // ctrl+shift+e
    "ctrl+shift+u": S_RTL, // ctrl+shift+u
    "ctrl+shift+a": S_ARABIC, // ctrl+shift+a
    "ctrl+shift+c": S_SOURCE_CODE, // ctrl+shift+c
    "ctrl+shift+d": S_REMOVE_FORMAT, // ctrl+shift+d
    "ctrl+shift+1": S_TEXTSIZE_1, // ctrl+shift+1
    "ctrl+shift+2": S_TEXTSIZE_2, // ctrl+shift+2
    "ctrl+shift+3": S_TEXTSIZE_3, // ctrl+shift+3
    "ctrl+shift+4": S_TEXTSIZE_4, // ctrl+shift+4
    "ctrl+shift+5": S_TEXTSIZE_5, // ctrl+shift+5
    "ctrl+shift+6": S_TEXTSIZE_6, // ctrl+shift+6
};

function getContext(code: string | null) {
    if (!code) {
        return null;
    }

    if ([S_RTL, S_LTR, S_SOURCE_CODE, S_REMOVE_FORMAT].includes(code)) {
        return CTX_MORE;
    }

    if (
        [
            S_TEXTSIZE_1,
            S_TEXTSIZE_2,
            S_TEXTSIZE_3,
            S_TEXTSIZE_4,
            S_TEXTSIZE_5,
            S_TEXTSIZE_6,
        ].includes(code)
    ) {
        return CTX_TEXT_SIZE;
    }

    return null;
}

export function isShortcut(evt: KeyboardEvent) {
    const shortcut: string[] = [];

    if (evt.altKey) {
        shortcut.push("alt");
    }

    if (evt.ctrlKey) {
        shortcut.push("ctrl");
    }

    if (evt.shiftKey) {
        shortcut.push("shift");
    }

    shortcut.push(evt.key);

    const s = shortcut.join("+");

    return {
        code: Object.keys(table).includes(s) ? table[s] : null,
        context: getContext(table[s]),
    };
}
